var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-nomore"},[_vm._v("\n  - 没有更多了 -\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }